import { PopoverContentProps } from "@/components/Popover/PopoverContentProps.ts";
import { t } from "i18next";
import { ArrowContainer } from "react-tiny-popover";

export const AvailabilityPopoverContent = ({
  position,
  childRect,
  popoverRect,
  text,
}: PopoverContentProps) => (
  <ArrowContainer
    position={position}
    childRect={childRect}
    popoverRect={popoverRect}
    arrowColor={""}
    className="popoverArrow"
    arrowSize={10}
  >
    <div className="popoverContent">{text || t("availabilityPopoverContent")}</div>
  </ArrowContainer>
);
